import { el, list } from 'redom';

import './index.scss';

class Variable {

  constructor() {

    this.path = el('td');
    this.description = el('td');

    this.el = el('tr', [
      this.path,
      this.description
    ]);

  }

  update(variable) {

    this.path.textContent = variable.path;
    this.description.textContent = variable.description;

  }

}

class VariablesDisplay {

  constructor(configuration, dialogConfiguration) {

    this.variables = list('tbody', Variable, 'path');

    this.variables.update(configuration.variables);

    this.el = el('#campaign-step-content-variables-display-main', [
      el('table', [
        el('thead', [
          el('tr', [
            el('th', 'Variable'),
            el('th', 'Description')
          ])
        ]),
        this.variables
      ])
    ]);

  }

}

export default VariablesDisplay;